export const replaceIdWithPath = (path: string) => {
  return ('/' + path.split('/')[1]) as PageRoute;
};

export enum PageRoute {
  COMPANIES = '/companies',
  CONTENT = '/content',
  CONTENT_PERKS = '/content-perks',
  CONTENT_TEMPLATES = '/content-templates',
  DASHBOARD = '/dashboard',
  ERROR = '*',
  HOME = '/',
  LOGIN = '/login',
  LOGS = '/logs',
  SETTINGS = '/settings',
  STAKEHOLDERS = '/stakeholders',
  TEAM = '/team',
}

export const pageTitle: Record<PageRoute, string> = {
  [PageRoute.HOME]: 'Home',
  [PageRoute.CONTENT]: 'Content',
  [PageRoute.CONTENT_PERKS]: 'Perks',
  [PageRoute.CONTENT_TEMPLATES]: 'Templates',
  [PageRoute.DASHBOARD]: 'Dashboard',
  [PageRoute.STAKEHOLDERS]: 'Stakeholders',
  [PageRoute.COMPANIES]: 'Companies',
  [PageRoute.TEAM]: 'Team',
  [PageRoute.LOGS]: 'Logs',
  [PageRoute.SETTINGS]: 'Settings',
  [PageRoute.LOGIN]: 'Login',
  [PageRoute.ERROR]: 'Error',
};
